import React from "react";
import UserRow from "./UserRow";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styles } from "../styles";

interface Props {
  userList: any;
}

const UserListing: React.FC<Props> = (props) => {
  const { userList } = props;
  const partners = Array.isArray(userList) ? userList : [];

  return (
    <Box sx={styles.section}>
      <Box sx={styles.sectionHead}>
        <Typography component="h2" sx={styles.sectionTitle}>
          Service partners{" "}
          <Box component="span" sx={styles.count}>
            {partners.length}
          </Box>
        </Typography>
      </Box>

      {partners.length > 0 ? (
        <TableContainer sx={styles.tableWrap}>
          <Table sx={styles.table} aria-label="service partners table">
            <TableHead sx={styles.tableHead}>
              <TableRow>
                <TableCell>User name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone number</TableCell>
                <TableCell>Salary</TableCell>
                <TableCell>Date of joining</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {partners.map((user: any, i: number) => (
                <UserRow key={user?.id || i} user={user} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography sx={styles.empty}>No service partners found</Typography>
      )}
    </Box>
  );
};

export default UserListing;
